import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Coaching from "./pages/Coaching";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivateCoaching from "./pages/PrivateCoaching";
import GroupCoaching from "./pages/GroupCoaching";
import AvailabilityForm from "./components/AvailabilityForm";
import Gear from "./pages/Gear";
import ProductDetails from "./pages/ProductDetails";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/coaching/private" element={<PrivateCoaching />} />
        <Route path="/coaching/group" element={<GroupCoaching />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/availability" element={<AvailabilityForm />} />
        <Route path="/gear" element={<Gear />} />
        <Route path="/gear/:id" element={<ProductDetails />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
